/*
 * @Description: 报价单相关路由
 * @Version: 2.0
 * @Autor: 胡彩丽 hucaili@qfei.cn
 * @Date: 2023-07-21 14:24:58
 * @LastEditors: 胡彩丽 hucaili@qfei.cn
 */
const DEFAULT_LAYOUT = () => import('@/layout/main-layout.vue');
const DEFAULT_PAGE = () => import('@/layout/page.vue');

const PRICESHEET = {
  path: '/price-sheet',
  name: 'price-sheet',
  component: DEFAULT_LAYOUT,
  redirect: { name: 'price-sheet-list' },
  meta: {
    title: '报价单',
    requiresAuth: true,
    hideChildrenInMenu: true,
    roles: 'priceSheet',
    order: 3
  },
  children: [
    {
      path: 'index',
      name: 'price-sheet-list-wrap',
      component: DEFAULT_PAGE,
      redirect: { name: 'price-sheet-list' },
      meta: {
        hideChildrenInMenu: true,
        requiresAuth: true,
        roles: 'priceSheet:view',
        title: '报价单管理'
      },
      children: [
        {
          path: '',
          name: 'price-sheet-list',
          component: () => import('@/views/sys-obj/sys-obj.vue'),
          props: { entity: 6 },
          meta: {
            requiresAuth: true,
            title: '报价单管理',
            roles: 'priceSheet:view'
          }
        },
        {
          path: ':id/collaborators',
          name: 'price-sheet-detail-collaborators',
          component: () => import('@/views/sys-obj/sys-obj.vue'),
          props: { entity: 6 },
          meta: {
            requiresAuth: true,
            title: '报价单管理详情',
            roles: 'priceSheet:view'
          }
        },
        {
          path: ':id',
          name: 'price-sheet-detail',
          component: () => import('@/views/sys-obj/sys-obj.vue'),
          props: { entity: 6 },
          meta: {
            requiresAuth: true,
            title: '报价单管理详情',
            roles: 'priceSheet:view'
          }
        }
      ]
    }
  ]
};

export default PRICESHEET;
